<template>
  <div id="app">
    <nav v-if="showNavbar" class="navbar navbar-expand-lg navbar-light bg-light" style="direction: rtl;">
      <div class="container-fluid">
        <span class="navbar-brand">MBFit Training Web</span>
        <button @click="logout" class="btn btn-danger btn-sm">
          تسجيل الخروج
        </button>
      </div>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentRoute: null
    };
  },
  computed: {
    showNavbar() {
      const token = localStorage.getItem('api_token');
      const routeName = this.$route.name;
      return token && routeName !== 'LoginForm';
    }
  },
  watch: {
    $route(to) {
      this.currentRoute = to.name;
      this.$forceUpdate();
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('api_token');
      this.$router.push({ name: 'LoginForm' });
    }
  }
};
</script>

<style>
#app {
  min-height: 100vh;
}

.navbar {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}
</style>
